import {datastageApi} from '../api';

export function startJobStatusTracker(jobId, onStatusMessage) {
    let stopped = false;
    let lastMessage = '';

    const poll = () => {
        datastageApi.jobs(jobId)
            .then((jobStatus) => {
                const data = jobStatus?.data;
                if (!data) {
                    const message = `Job ${jobId}: Unable to fetch status.`;
                    if (message !== lastMessage) {
                        onStatusMessage(message, 'error');
                        lastMessage = message;
                    }
                    if (!stopped) setTimeout(poll, 2000);
                    return;
                }

                let message = '';
                let status = 'info';

                if (data.spaJobStatus === 'STARTING') {
                    message = `Job ${data.id} is creating tasks and preparing to start.`;
                } else if (data.spaJobStatus === 'RUNNING') {
                    message = `Job ${data.id} progress: ${data.progressCount} out of ${data.targetCount} tasks complete with ${data.errorCount} errors.`;
                } else if (data.spaJobStatus === 'COMPLETE' && data.errorCount > 0) {
                   message = `Job ${data.id} upload completed with errors. ${data.errorCount} error${data.errorCount === 1 ? ' found' : 's found'}.`;
                    status = 'error';
                    stopped = true;
                } else if (data.spaJobStatus === 'COMPLETE') {
                    message = `Job ${data.id} completed successfully!`;
                    status = 'success';
                    stopped = true;
                } else if (data.spaJobStatus === 'FAILED') {
                    message = `Job ${data.id} failed!`;
                    status = 'error';
                    stopped = true;
                } else if (data.spaJobStatus === 'CANCELLED') {
                    message = `Job ${data.id} was cancelled.`;
                    status = 'warning';
                    stopped = true;
                } else {
                    message = `Job ${data.id} is in an unknown state: ${data.spaJobStatus}`;
                    status = 'error';
                }

                if (message && message !== lastMessage) {
                    onStatusMessage(message, status);
                    lastMessage = message;
                }

                if (!stopped) setTimeout(poll, 2000);
            })
            .catch(() => {
                const message = `Job ${jobId}: Error fetching status.`;
                if (message !== lastMessage) {
                    onStatusMessage(message, 'error');
                    lastMessage = message;
                }
                stopped = true;
            });
    };

    poll();
}